export { default } from '@/fragments/shop-administration/order/best-sellers';
